import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BaseContainer from '../common/BaseContainer';
import ControlHeader from '../common/ControlHeader';
import CampaignForm from './CampaignForm';

import fetch from '../../utils/fetcher';
import { baseUrl, getFormToRequestData, initialValues } from './config';
import {
  translateQuestionsDictionary,
} from '../CampaignFormQuestionnaire/AddQuestionModalContent/questionTypesConsts';
import { useVisible } from '../common/AlertManager';
import useStyles from './styles';

const CreateCampaign = () => {
  const [alertError, setAlertError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const { visible: isErrorVisible, open: openError } = useVisible(false);
  const { t } = useTranslation(['translation']);
  const classes = useStyles();

  const formToRequestData = getFormToRequestData(translateQuestionsDictionary(t));

  const onSubmit = (values, actions) => {
    fetch(baseUrl, formToRequestData(values)).then(() => {
      setSubmitted(true);
    }).catch(e => {
      openError();
      setAlertError(e);
    }).finally(() => {
      actions.setSubmitting(false);
    });
  };

  if (submitted) {
    return <Redirect to="/campaigns" />;
  }

  return (
    <BaseContainer>
      <ControlHeader
        title={t('CAMPAIGN.CREATE_CAMPAIGN_TITLE')}
        showBack
        overriddenClasses={{ titlePart: classes.campaignTitlePart }}
        goBackUrl="/campaigns"
      />
      <CampaignForm
        values={initialValues}
        onSubmit={onSubmit}
        alertError={alertError}
        buttonText={t('CAMPAIGN.CREATE_CAMPAIGN_SUBMIT_BUTTON_TEXT')}
        editMode={false}
        isErrorVisible={isErrorVisible}
      />
    </BaseContainer>
  );
};

export default CreateCampaign;
